export const chainablePropType = predicate => {
  const propType = (props, propName, componentName) => {
    if (props[propName] == null) {
      return;
    }
    return predicate(props, propName, componentName);
  };
  propType.isRequired = (props, propName, componentName) => {
    if (props[propName] == null) {
      return new Error("Required prop `".concat(propName, "` was not specified in `").concat(componentName, "`."));
    }
    return predicate(props, propName, componentName);
  };
  return propType;
};